module.exports = __webpack_public_path__ + "static/media/daycareCozyAreaIcon.c6608b7d.png";